export default __webpack_public_path__ + "static/media/letterboard.53f425ea.png";